import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classNames } from '@framework/utils';
import type { ReactNode } from 'react';

type Props = {
  handleClick: () => void;
  title: string;
  className?: string;
  disabled?: boolean;
} & (
  | {
      icon: IconProp;
      iconClassName?: string;
    }
  | {
      iconNode: ReactNode;
    }
);

export const SidebarMenuButton: React.FC<Props> = ({
  handleClick,
  title,
  className = '',
  disabled = false,
  ...props
}: Props) => {
  return (
    <button
      className={classNames(
        'block w-full px-3 py-1 text-left',
        disabled ? 'cursor-not-allowed text-gray-500' : 'text-gray-800 hover:bg-indigo-500 hover:text-white',
        className
      )}
      onClick={handleClick}
      disabled={disabled}
    >
      {'icon' in props && (
        <span className={props.iconClassName}>
          <FontAwesomeIcon icon={props.icon} />
        </span>
      )}
      {'iconNode' in props && props.iconNode}

      <span className="ml-2">{title}</span>
    </button>
  );
};
